import request from "@/utils/request";

// 列表(主数据列表)
export function loadSurveyCityCountSettingListDataApi(data) {
    return request({
      url: "web/surveyCityCountSetting/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadSurveyCityCountSettingExportDataApi(data) {
    return request({
      url: "web/surveyCityCountSetting/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateSurveyCityCountSettingApi(data) {
    return request({
      url: "web/surveyCityCountSetting/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initSurveyCityCountSettingApi(data) {
    return request({
      url: "web/surveyCityCountSetting/init",
      method: "post",
      data
    });
  }
  
  // 下拉列表（下拉选择）
  export function loadSurveyCityCountSettingListApi(data) {
    return request({
      url: "web/surveyCityCountSetting/listSelectData",
      method: "post",
      data
    });
  }